import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Link } from "react-router-dom";
import { toast } from 'react-toastify';
import * as action from '../Action/AdsSetting/AdsSetting_Action';
import Loader from "./Loader";
import { useAuth } from "../context/Context";

const AdsSetting = () => {
    const { user } = useAuth();
    const dispatch = useDispatch();
    const hasFetched = useRef(null);
    const { loading } = useSelector(state => state.GetAdsPLatformListReducer);
    const [data, setData] = useState([]);

    useEffect(() => {
        if(hasFetched.current) return;
        hasFetched.current = true;

        const getData = () => {
            dispatch(action.getAdsPLatformList()).then((action) => {
                const rd = action.responseDetails;
                if (Array.isArray(rd)) {
                    setData(rd);
                } else if (rd && typeof rd === 'object') {
                    setData([{
                        id: rd.id,
                        ad_platform_name: rd.ad_platform_name || rd.platform || 'Ads Configuration',
                        ad_platform_image: null,
                        status: rd.is_active,
                    }]);
                } else {
                    setData([]);
                }
            }).catch(() => {
                setData([]);
            });
        }

        getData();
    }, [dispatch]);
    const handleToggle = (id, status) => {
        const isAccessAllowed = user?.login_type !== 'Guest';

        if (!isAccessAllowed) {
            toast.error("Opps! You don't have Permission.");
            return false;
        }
        
        let requestData = {
            id: id,
            status: status === 1 ? "0" : 1
        }
        dispatch(action.updateAdsPLatformStatus(requestData)).then((response) => {
            toast.success(response.responseMessage || response.message || 'Status updated successfully');
            setData((prevData) =>
                Array.isArray(prevData) ? prevData.map((item) =>
                    item.id === id ? { ...item, status: requestData.status } : item
                ) : prevData
            );
        }).catch(error => {
            toast.error(error?.responseMessage || error?.message || 'An error occurred. Please try again.');
        })
    }
    return (
        <>
            { loading ? <Loader /> : 
                <>
                    <section>
                        <div className="row">
                            {data.map((item, index) => (
                                <div className="col-lg-4 col-md-6 col-sm-6 col-xs-6" key={`playform_${item.id}`}>
                                    <div className="card m-b-20 p-3 ads_block_card">
                                        <div className="ads_logo_item">
                                            {item.ad_platform_image ? (
                                                <img className="card-img-top thumb-lg img-fluid" src={item.ad_platform_image} alt={item.ad_platform_name} onError={(e) => { e.target.style.display = 'none'; }} />
                                            ) : (
                                                <div className="d-flex align-items-center justify-content-center" style={{height:'60px',fontSize:'2rem',color:'#ccc'}}><i className="fas fa-ad"></i></div>
                                            )}
                                        </div>
                                        <div className="card-body p-0">
                                            <h4 className="card-title mb-4">{item.ad_platform_name}</h4>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <Link to={"/ads-setting/"+ item.id} className="btn waves-effect waves-light btn-success m-r-5" data-toggle="tooltip" title="" data-original-title="Edit"> <i className="fa fa-edit"></i> Edit </Link>
                                                <div className="checkbox-slider d-flex align-items-center">
                                                    <label>
                                                        <input type="checkbox" className="d-none hideContent is_admon" checked={parseInt(item.status) === 1} onChange={() => handleToggle(item.id, item.status)}/>
                                                        <span className="toggle_background">
                                                            <div className="circle-icon"></div>
                                                            <div className="vertical_line"></div>
                                                        </span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </section>
                </>
            }
        </>
    );
};

export default AdsSetting;
